/**
 * Auth-path debug logging toggle.
 *
 * Off in production by default. Enable per-tab via the browser console:
 *
 *     localStorage.setItem('debug.auth', '1')
 *
 * Then reload. Every RoleGuard / useCurrentUser / AuthContext state
 * transition logs to the console with the prefix `[auth.*]`. Disable:
 *
 *     localStorage.removeItem('debug.auth')
 *
 * Lives in its own module so we can grep for `debugAuth()` to find every
 * gated log when we eventually rip these out.
 */
export function debugAuth(): boolean {
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem('debug.auth') === '1';
  } catch {
    return false;
  }
}
